import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-marketing-data',
  templateUrl: './marketing-data.component.html',
  styleUrls: ['./marketing-data.component.css']
})
export class MarketingDataComponent implements OnInit {

  marketingForm: any | FormGroup;
  updateMarketingStatus: any | FormGroup
  updateMarketingForm: any | FormGroup;
  marketingData: any= []
  singleMarketingData: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  buttondisable = false
  TypeData:any = []
  tagUsersdropdownList  = [];
  tagUsersselectedItems:any = [];
  tagUsersdropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  usersList: any= []
  statusList: any=[]
  latestStatus = ""
  toggleStatus = false;
  marketingId = 0;
  labels:any = [];
  addMarketingButton = false;
  marketingFormSubmit = false;
  updateMarketingStatusSubmit = false;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getMarketingData()
    this.getAllStatus()
    this.getParamByType()
    this.getUsers()
    this.marketingForm = this.fb.group({
      name: ['',[Validators.required]],
      phone: ['',[Validators.required,
        Validators.maxLength(10),
        Validators.minLength(10),
        Validators.pattern("[0-9 ]{10}") ]],
      email: ['',[Validators.required,
        Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$")]],
      assignedToUser: [''],
      keyValueList:this.fb.array([])
    })

    this.updateMarketingForm = this.fb.group({
      status: [''],
      note: ['']
    })

    this.updateMarketingStatus = this.fb.group({
      status: ['',[Validators.required]],
      note: ['',[Validators.required]],
    }) 
  }

  getAllStatus(){
    this.generic_service.getAllStatusMaster().subscribe(
      (res:any)=>{
        this.statusList = res.response;
      }
    )
  }

  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
        this.tagUsersdropdownList = res.response;
      }
    )
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getMarketingData();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getMarketingData();
  }

  get marketingArr(){
    return this.marketingForm.get('keyValueList') as FormArray;
  }

  addButton(){
    this.marketingFormSubmit = false;
  }

  addMarketingData(){
    this.marketingFormSubmit = true;
    if(!this.marketingForm.valid){
      console.log(this.marketingForm.value)
      return
    }
    this.buttondisable = true;

    console.log(this.tagUsersselectedItems)
    let tagUserList:any = []
    for(let user of this.tagUsersselectedItems){
      tagUserList.push(Number(user.userId))
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": 0,
      "name": String(this.marketingForm.get('name').value),
      "phone": String(this.marketingForm.get('phone').value),
      "email": String(this.marketingForm.get('email').value),
      "keyValueList": this.marketingForm.get('keyValueList').value,
 
      "marketingStatusList": [
        {
          "status": "Created",
          "userId": String(sessionStorage.getItem('userId')),
          "note": "Ticket Created by"+" " + sessionStorage.getItem('userName'),
          "statusDate": new Date().getTime()
        }
      ],
      "latestStatus": "Created",
      "latestStatusUserId": Number(sessionStorage.getItem('userId')),
      "latestStatusDate": new Date().getTime(),
      "tagUserList": tagUserList,
      "assignedToUser": Number(this.marketingForm.get('assignedToUser').value),
      "serialNo": 0,
      "cid": this.cid,
    }

    console.log(body)
    this.generic_service.addMarketingData(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getMarketingData()
        this.toastr.success(response.message)
        this.cancelModel()
        this.marketingForm.reset()
        this.buttondisable = false;
        this.marketingFormSubmit = false;
        this.marketingForm.patchValue({
          name: '',
          phone: '',
          email: '',
          assignedToUser: ''
        });
        this.marketingForm.controls['keyValueList'].clear();

        // let formArray = this.marketingForm.get('keyValueList').value
        // for(let i =0; i <= this.marketingArr.length;i++){
        //   this.marketingArr.removeAt(0)
        // }
        console.log(this.marketingForm.value)

        // if(formArray.length !== 0) {
        //   this.marketingArr.removeAt(0)
        // }
    
        for(let i=0; i < this.TypeData.length; i++){
          let arr:any = this.fb.group({
             "key": [this.TypeData[i].name],
             "value": ['']
           })
           this.marketingArr.push(arr) 
         }
         console.log(this.marketingForm.value)
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.error[0].description)
      }
    )
  }

  updateMarketingData(){
    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.singleMarketingData[0].description),
      "id": this.singleMarketingData[0].id,
      "name": String(this.singleMarketingData[0].name),
      "phone": String(this.singleMarketingData[0].phone),
      "email": String(this.singleMarketingData[0].email),
      "keyValueList": this.singleMarketingData[0].keyValueList,
      "marketingStatusList": this.singleMarketingData[0].marketingStatusList,
      "latestStatus": String(this.singleMarketingData[0].latestStatus),
      "latestStatusUserId": String(this.singleMarketingData[0].latestStatusUserId),
      "latestStatusDate": new Date().getTime(),
      "tagUserList": this.singleMarketingData[0].tagUserList,
      "assignedToUser": Number(this.singleMarketingData[0].assignedToUser),
      "serialNo": Number(this.singleMarketingData[0].serialNo),
      "cid": Number(this.singleMarketingData[0].cid),
      "marketingDataId": Number(this.singleMarketingData[0].marketingDataId),
      "createdDate": new Date().getTime()
    }
    console.log(body)
    console.log(this.singleMarketingData)

    this.generic_service.updateMarketingData(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getMarketingData()
        this.toastr.success(response.message)
        this.getMarketingDataById(this.marketingId)
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.error[0].description)
      }
    )
  }

  getMarketingData(){
    this.generic_service.getMarketingData().subscribe(
      (response:any)=>{
        console.log(response)
        this.marketingData = response.response
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getMarketingDataById(id:any){
    this.marketingId = Number(id);
    this.generic_service.getMarketingDataById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.singleMarketingData = []
        this.latestStatus = response.response.latestStatus
        this.singleMarketingData.push(response.response);
        document.getElementById("template-view")?.click()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  showStatus(){
    this.toggleStatus = true;
  }

  updateStatusClose(){
    this.updateMarketingStatus.reset();
    this.updateMarketingStatusSubmit = false;
    this.toggleStatus = false;
  }

  updateStatus(){
    this.updateMarketingStatusSubmit = true;
    if(!this.updateMarketingStatus.valid){
      console.log(this.updateMarketingStatus.value)
      return
    }
    let body = {
      "status": String(this.updateMarketingStatus.get('status').value),
      "userId": String(sessionStorage.getItem('userId')),
      "note": String(this.updateMarketingStatus.get('note').value),
    }
    console.log(body);

    this.generic_service.updateMarketingDataStatus(body,this.marketingId).subscribe(
      (response:any)=>{
        console.log(response);
        this.toggleStatus = false;
        this.updateMarketingStatus.reset();
        document.getElementById("updateClose")?.click()
        this.getMarketingDataById(this.marketingId)
        this.updateMarketingStatusSubmit = false;
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getLabel(index:any){
    return "apple"
  }

  getParamByType(){
    let type = 'MDPARAMS'
    this.generic_service.getParamByType(type).subscribe(
      (res:any)=>{
        console.log(res)
        this.TypeData = res.response
        console.log(this.TypeData)
        for(let i=0; i<res.response.length; i++){
         let arr:any = this.fb.group({
            "key": [res.response[i].name],
            "value": ['']
          })
          this.marketingArr.push(arr)
          this.labels.push(res.response[i].name)

        }
        console.log(this.marketingForm.value)
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

}